import PageLayout from '@/components/feature/PageLayout';
import Hero from '@/pages/home/components/Hero';
import Marquee from '@/pages/home/components/Marquee';
import HowWeWork from '@/pages/home/components/HowWeWork';
import Platforms from '@/pages/home/components/Platforms';
import HowWeGetResults from '@/pages/home/components/HowWeGetResults';
import SectionsOverview from '@/pages/home/components/SectionsOverview';

export default function Home() {
  return (
    <PageLayout>
      <Hero />
      <Marquee />
      <HowWeWork />
      <Platforms />
      <HowWeGetResults />
      <SectionsOverview />
    </PageLayout>
  );
}